import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSortDescSmall(props: IconProps) {
  return (
    <BaseIcon viewBox="0 0 16 16" size={16} {...props}>
      <path
        fill="currentColor"
        d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5ZM10.5 6a.5.5 0 0 1 .5.5v4.793l1.146-1.147a.5.5 0 0 1 .707.708l-2 2a.5.5 0 0 1-.707 0l-2-2a.5.5 0 0 1 .707-.708L10 11.293V6.5a.5.5 0 0 1 .5-.5ZM3.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM3 9.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM3.5 12a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
      />
    </BaseIcon>
  );
}
